import { APP_LANGUAGES } from '../config/client.config';

/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 * Based on https://github.com/react-boilerplate/react-boilerplate/blob/master/app/i18n.js
 */

/* NOTE: MASTER_FILE_LANGUAGE is only for EXTRACTING the messages from
         components. The result is a master translation file in
         ./translations/en.json which can be uploaded to Locize (or
          any translation service).
*/
const MASTER_FILE_LANGUAGE = [APP_LANGUAGES[0]];
const DEFAULT_LOCALE = APP_LANGUAGES[0];

export { APP_LANGUAGES, MASTER_FILE_LANGUAGE, DEFAULT_LOCALE };
